import React, { useEffect, useState } from "react"
import axios from 'axios';
import { dbUrlAllQuotes, dbUrlWTDlist, customStyles2 } from '../Constants';
import '../wisdom.css';
import { animateScroll as scroll } from "react-scroll";
import ReadMoreAndLess from "react-read-more-less";
import Select from 'react-select';
//import { Link } from 'react-router-dom';
import Highlighter from "react-highlight-words";
import {DebounceInput} from 'react-debounce-input';
import SEO from "../../SEO";
import {useParams} from 'react-router-dom';

const QuotesAll = () => {
    const [quotes, setQuotes] = useState([])
    const [list, setList] = useState([])
    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(true);
    const [error, setError] = useState(null)
    const [errorList, setErrorList] = useState(null)
    const [searchString, setSearchString] = useState('')
    const [selectedAuthor, setSelectedAuthor] = useState(null)

    const params = useParams();

    //console.log(params);

    let filterQuotes, searchWords
    
    useEffect(() => {
        const fetchQuotes = () => {
          axios.get(dbUrlAllQuotes)
          .then(response => {
            setLoading2(false)
            setQuotes(response.data)
          }).catch(error => {
            setError(error);
          });
        }

        const fetchList = () => {
            axios.get(dbUrlWTDlist + 'all-quotes')
            .then(response => {
                setLoading(false)
                setList(response.data)
            }).catch(errorList => {
                setErrorList(errorList);
            });
        }
        fetchList()
        fetchQuotes()
      }, [params.slug])
  
    if (error) return `Error: ${error.message|errorList.message}`;


    const handleSearchChange = (e) => {
        setSearchString(e.target.value);
      };
    
    
    const clearSearchField = (e) => {
        setSearchString('')
        }

    const handleAuthorChange = (selectedOption) => {
        setSelectedAuthor(selectedOption);
        console.log(`Option selected:`, selectedOption);
        };

    const clearFilterAuthor = (e) => {
        setSelectedAuthor(null);
    } 
    /* 
    clearFilterArtist(){
        this.setState({
            selectedOptionArtist: null, 
            })
        }
    
    */
    
   
    
    function SearchQuotes(searchText) { 
        let searchArray = [];
        let searchQuote;
        
        for (let i = 0; i < quotes.length; i++) {

            searchQuote = quotes[i].quote.toLowerCase();

            if (searchQuote.includes(searchText))
            
            //if (quotes[i].quote.includes(searchText))
            
                {searchArray.push(quotes[i]);}
        } 
        return searchArray
    }


    const scrollToTop = () => {
        scroll.scrollToTop(); 
    };


    if (searchString) {
        searchWords = searchString.split(/\s/).filter(word => word)
        filterQuotes = SearchQuotes(searchString.toLowerCase());
        } 
    if (selectedAuthor && !searchString) {
        filterQuotes = quotes.filter(e => e.author === selectedAuthor.value);
        }  
    if (!searchString && !selectedAuthor) {
        filterQuotes = quotes;
    }
   
    //remove null
    //const NullAuthors = quotes.filter(Boolean);
    const NullAuthors = quotes.filter((value) => value.author != null);
    //get only author
    const OnlyAuthor = NullAuthors.map(item => item.author);
    //unique artist + count
    const uniqueAuthor = OnlyAuthor.reduce((b,c) => (
        (b[b.findIndex(d => d.author===c)] ||
        // eslint-disable-next-line 
        b[b.push({author: c, count: 0})-1]).count++,b), 
        []
    );
    const uniqueAuthorSorted = uniqueAuthor.sort(function(a, b){
       return b.count-a.count
   })
    //map Author with count to AuthorOptions
    const AuthorOptions = uniqueAuthorSorted.map(value => { 
        return {value: value.author, label: value.author + ' (' + value.count + ')'}; 
    });

    if (loading || loading2) {
        return <div>
                <main className="my-4 py-4"><div className="container"> 
                <div className="row pt-5"><div className="col">
                <h4>Loading...</h4></div></div></div></main>;
            </div>
    }

    if (list.length < 1) {
        return <div>
                    <main className="my-1 py-1">
                        <div className="container">  
                            <div className="row pt-1">
                                <div className="col">
                                    <h1>404 - Not Found!</h1>
                                    
                                </div>
                            </div>
                        </div>
                    </main>
            </div> 
    }

    const {name, description, pic_link, page} = list[0];

    const ListHeading = list.map(value => {
        
        return (
            <React.Fragment key={value.id}>
            
                <div className="row mb-3 gx-5">
                    <div className="col-sm-6 Description">
                        <div>
                            <h1>{value.name}</h1>
                        </div>
                        <div className="p-3 border bg-light">
                            {value.description} 
                        </div>
                        <div className="d-flex p-2">
                            {((window.location.hostname === "localhost") || (value.in_progress)) &&
                                <div className="text-center">
                                    <div className="btn btn-light btn-sm mt-2"><b>In progress</b></div>
                                <div className="text-center">
                                    <div className="btn btn-info btn-sm mt-2">total count: {quotes.length}</div>
                                </div> 
                                </div>
                                } 
                        </div>
                    </div>
                    <div className="col-sm-6 d-none d-sm-block">

                        {/* <input type="text" value={searchString} onChange={handleChange} /> &nbsp; */}
                        <div className="row">   
                                <div className="col">
                                    <h4>Search</h4>
                            </div>
                        </div>
                        
                        <div className="row mb-2">  
                            <div className="col-sm-5 mt-1">
                                <div className="search">  
                                    <DebounceInput
                                        minLength={3}
                                        debounceTimeout={500}
                                        value={searchString}
                                        onChange={handleSearchChange}
                                        placeholder="Search all quotes" 
                                        
                                    />
                                </div>
                               
                            </div>
                            <div className="col-sm-7 mt-1">
                                <button type="button" className="btn btn-primary btn-sm"  
                                    onClick={() => clearSearchField()} > Reset </button>
                            </div>
                        </div>

                        <div className="row">   
                                <div className="col">
                                    <h4>Filter</h4>
                            </div>
                        </div>

                        <div className="row">  
                            <div className="col-sm-5 mt-1">
                                    <Select
                                        className="select"
                                        value={selectedAuthor}
                                        onChange={handleAuthorChange}
                                        //onChange={selectedOptionArtist}
                                        options={AuthorOptions}
                                        placeholder='select Author'
                                        styles={customStyles2}
                                        autoFocus={true}
                                    />
                            </div>
                            <div className="col-sm-7 mt-1">
                                <button  className="btn btn-primary btn-sm"  onClick={() => clearFilterAuthor()} >Reset</button>
                            </div>
                        </div>
                            
                        
                        

                    </div>
                </div>
                   
            </React.Fragment>
            )
    })

    const QuoteItems = filterQuotes.map(value => {

        let dead, born
        if (value.dead_date||value.dd_text) {
            dead = " - ";
            born = "(";
        }
        else {
            born = "(Born: ";
        }

        return (

            <React.Fragment key={value.id}>
                <div className="row pt-3 pb-3 border-bottom border-top border-info">

                    {/* kolonne 1 */}
                    <div className="col-sm-7">
                     

                         <div className='m-2'>

                            <div className="card">

                                <div className='row'>
                                    <div className='col-sm-5'>

                                        {value.quote_picture &&
                                            <div className='p-4'>
                                                <img src={value.quote_picture} alt="" height={value.pic_height|'250'} width={value.pic_height|'250'}
                                                className="rounded mx-auto d-block img-fluid"></img>
                                            </div>
                                        }

                                        {!value.quote_picture && value.picture_link && !value.album_cover_link &&
                                            <div className='p-4'>
                                                <img src={value.picture_link} alt="" height={value.pic_height|'250'} width={value.pic_height|'250'}
                                                className="rounded mx-auto d-block img-fluid"></img>
                                            </div>
                                        }
                                        {!value.quote_picture && !value.picture_link && value.album_cover_link &&
                                            <div className='p-4'>
                                                <img src={value.album_cover_link} alt="" height={value.pic_height|'250'} width={value.pic_height|'250'}
                                                className="rounded mx-auto d-block img-fluid"></img>
                                            </div>
                                        }
                                        {!value.quote_picture && !value.picture_link && !value.album_cover_link &&
                                            <div className='p-4'>
                                                <img src={value.picture} alt="" height={value.pic_height|'250'} width={value.pic_height|'250'}
                                                className="rounded mx-auto d-block img-fluid"></img>
                                            </div>
                                        }
                                    </div>

                                    <div className='col-sm-7'>
                                        <div className="card-body mt-3"> 

                                            {
                                                (() => {
                                                if (value.old_font && !searchString) 
                                                return <div className="QuoteOld">&nbsp;&nbsp;&nbsp;{value.quote}</div> 
                                                if (value.old_font && searchString)
                                                return <div className="QuoteOld">
                                                            <Highlighter
                                                                highlightClassName="YourHighlightClass"
                                                                searchWords={searchWords}
                                                                autoEscape={true}
                                                                textToHighlight={value.quote}
                                                            />
                                                        </div> 
                                                if (!value.old_font && !searchString)
                                                return <div className="quote16">{value.quote}</div> 
                                                if (!value.old_font && searchString)
                                                return <div className="quote16">
                                                            <Highlighter
                                                                highlightClassName="YourHighlightClass"
                                                                searchWords={searchWords}
                                                                autoEscape={true}
                                                                textToHighlight={value.quote}
                                                            />
                                                        </div> 
                                                })()
                                            }


                                            <h6 className="card-title mt-3">{value.author}</h6>

                                            {
                                                (() => {
                                                if (value.author && (value.birth_date || value.bd_text)) {
                                                return <div className="SmallText">
                                                            {born}{value.bd_text||value.birth_date}
                                                            {dead}
                                                            {value.dd_text||value.dead_date})
                                                        </div>
                                                }
                                                return 
                                                })()
                                            }

                                        </div>

                                    </div>
                                </div>

                            </div>

                            <div className="mt-2">
                                        {
                                            (() => {
                                            if (value.source_txt) {
                                            return <div className="Description"> 
                                                        <b>&nbsp; Source: </b>{value.source_txt}
                                                        {
                                                            (() => {
                                                            if (value.year||value.year_txt) {
                                                            return <span>&nbsp; ({value.year||value.year_txt})
                                                                        </span>
                                                            }
                                                            return 
                                                            })()
                                                        }
                                                    </div>
                                            } if (value.song_title && value.album_title) {
                                                return <div className="Description"> 
                                                        <b>&nbsp; Song: </b>{value.song_title}
                                                        {
                                                            (() => {
                                                            if (value.year||value.year_txt) {
                                                            return <span>&nbsp; ({value.year||value.year_txt})
                                                                        </span>
                                                            }
                                                            return 
                                                            })()
                                                        }
                                                        <div><b>&nbsp; Album: </b>{value.album_title}</div>
                                                    </div>
                                            }
                                            if (value.title && !value.source_txt) {
                                                return <div className="Description"> 
                                                            <b>&nbsp; Source: </b>{value.title}
                                                            {
                                                                (() => {
                                                                if (value.year||value.year_txt) {
                                                                return <span>&nbsp; ({value.year||value.year_txt})
                                                                            </span>
                                                                }
                                                                return 
                                                                })()
                                                            }
                                                        </div>
                                                }
                                            return 
                                            })()
                                        }
                                
                            </div>
                        
                        </div>
                        

                    </div>

                    {/* 2 kolonne */}
                    <div className="col-sm-5 p-2 border-right Description">

                        <div className="row">
                            <div className="col py-2 border-right Description">

                                {
                                    (() => {
                                    if (value.comment && value.comment_quote) {
                                        return <div>
                                                    <div className='mx-3 mb-3'>
                                                        <ReadMoreAndLess
                                                            charLimit={800}
                                                            readMoreText={" Read more ▼"}
                                                            readLessText={" Read less ▲"}
                                                            readMoreClassName="read-more-less--more"
                                                            readLessClassName="read-more-less--less"
                                                        >
                                                        {value.comment}
                                                        </ReadMoreAndLess> 
                                                    </div>

                                                    <div className="card bg-light pt-1 px-2 mx-3">
                                                        <div className="quote13 mb-4">{value.comment_quote}</div>
                                                        <div className="blockquote-footer"><i>{value.comment_quote_source}</i></div>
                                                    </div>
                                            </div>
                                    }
                                    if (value.comment && !value.comment_quote) {
                                        return <div className='mx-3'>
                                                <ReadMoreAndLess
                                                    charLimit={800}
                                                    readMoreText={" Read more ▼"}
                                                    readLessText={" Read less ▲"}
                                                    readMoreClassName="read-more-less--more"
                                                    readLessClassName="read-more-less--less"
                                                >
                                                {value.comment}
                                                </ReadMoreAndLess> 
                                            </div>
                                   
                                    } if (!value.comment && value.comment_quote) {
                                        return <div className="card bg-light pt-1 px-2">
                                                <div className="quote13 mb-4">{value.comment_quote}</div>
                                                <div className="blockquote-footer"><i>{value.comment_quote_source}</i></div>
                                            </div>
                                    }
                                    return 
                                    })()
                                }

                                {
                                    (() => {
                                    if (value.q_more_info) {
                                    return <p className="Description"> 
                                                <br /> <em> -> <a href={value.q_more_info}>more info..</a></em>
                                            </p>
                                    }
                                    return 
                                    })()
                                }
                                

                            </div>
                        </div>

                    </div>

                </div>

            </React.Fragment>

        )

    })
    
    return (
        <main className="my-1 py-1">
            {quotes.length > 0 && (
                <div className="container">

                 <SEO
                    title={name}
                    description={description}
                    name={name}
                    picture_link={pic_link}
                    url={'https://www.wisdomthisday.com/'+page}
                    type='article' />


                    <div className="row">
                        <div className="col">
                            {ListHeading}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            {QuoteItems}
                        </div>
                    </div>

                    <p align="Right"><br />
                        <button type="button" className="btn btn-primary btn-sm" onClick={scrollToTop}>
                        <b>Scroll to top</b></button>
                    </p>


                </div>
            )}
        </main>
    )
}

export default QuotesAll